import useRoleDocuments from '../../pageInside/roleDocuments/useRoleDocuments';
import RoleDocumentContent from '../../pageInside/roleDocuments/RoleDocumentContent';
import { DOCUMENT_STATUS } from '../../../utils/roleDocuments';
import { acceptEventRoleToken } from '../../auth/apiRoleTokens';
import { tokenText } from '../roleTokens/tokenText';
import { roleDisplayLabel } from '../../../utils/roleDisplayLabel';
import ElakayImage from '../../../components/images/ElakayImage';
import React, { useEffect, useMemo, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import Pages from "../LanguagePage";
import nodata from "../../Layout/imgs/nodata0.png";
import {
  authenticate,
  createRoleChangeRequest,
  findRoleChangeAssociates,
  getPublicAgentProfile,
  UserStepUP,
  getElakayLang
} from "../../auth";
import "./Stepaboutuser.css";
import ThirdLevelCategorySelector from "../../pageInside/ThirdLevelCategorySelector";
import CountryZipLocationFields from "../../pageInside/CountryZipLocationFields";
import SpecializedCategories from "../../pageInside/SpecializedCategories";
import LanguageSelector from "../../pageInside/LanguageSelector";
import LanguageBadges from "../../pageInside/LanguageBadges";
import ProfessionalVideoPlayer from "../../pageInside/ProfessionalVideoPlayer";
import ExpandableTextarea from "../../pageInside/ExpandableTextarea";
import ExpandableApplicationSection from "../../pageInside/ExpandableApplicationSection";
import ApplicationLinksEditor from "../../pageInside/applicationLinks/ApplicationLinksEditor";
import { cleanApplicationLinks, validateApplicationLinks } from "../../../utils/applicationLinks";
import { REQUIRED_APPLICATION_QUESTION_IDS } from "../../../utils/roleApplicationQuestions";
import { elakayAutoText } from "../../pageInside/dataElakay";


const CONTENT_BY_ROLE = {
  Royalty: { objective: "planUserRoyal", terms: "termConditionRoyal", final: "royalAgree" },
  Seller: { objective: "planUserSeller", terms: "termConditionSeller", final: "sellerAgree" },
  Provider: { objective: "planUserProvider", terms: "termConditionProvider", final: "providerAgree" },
  Associate: { objective: "planAffaireElakay", terms: "termConditionAssociate", final: "associateAgree" },
  Investment: { objective: "planProInvestElakay", terms: "termConditionInvest", final: "investmentAgree" },
  Administrator: { objective: "planProAdminElakay", terms: "termConditionAdmin", final: "AdministratorAgree" },
  // Real FrTxtLanguage field names (see utils/roleDocuments.js).
  Family: { objective: "planProFamillyElakay", terms: "termConditionFamilly", final: "FamillyAgree" }
};

const isApprovalRole = (roleName) => roleName === "Seller" || roleName === "Provider";
const AGENTS_PER_PAGE = 6;
const EMPTY_APPLICATION_ANSWERS = {
  aboutYourself: "",
  experience: "",
  motivation: "",
  goals: "",
  communityContribution: "",
  localCommunityImpact: "",
  longTermGoals: "",
  additionalInformation: ""
};
const REQUIRED_APPLICATION_KEYS = REQUIRED_APPLICATION_QUESTION_IDS;

const agentCardName = (agent = {}) => {
  const publicName = String(agent.displayName || "").trim();
  const fullName = String(agent.fullName || "").trim();

  // The current API uses the full name as displayName when no public name was
  // configured. Comparing both lets the card preserve the public-name priority
  // without changing the response contract.
  if (publicName && publicName !== fullName) return publicName;

  const nameParts = fullName.split(/\s+/).filter(Boolean);
  const firstName = nameParts[0] || publicName || agent.initials || "";
  const lastInitial = nameParts.length > 1
    ? `${nameParts[nameParts.length - 1].charAt(0).toUpperCase()}.`
    : "";

  return [firstName, lastInitial].filter(Boolean).join(" ");
};

const StepAboutUser = ({
  showRole,
  setShowRole,
  infoSource,
  token,
  userActiveRole,
  onRequestCreated,
  maxAgentSelections,
  promoContext,
  eventContext,
  onEventAccepted,
  externalApplication,
  requestApprovalComplete = true,
  onCompleteRequestApproval,
  inlineFinalOnly = false
}) => {
  const content = CONTENT_BY_ROLE[userActiveRole.roleName] || CONTENT_BY_ROLE.Royalty;
  const approvalRequired = isApprovalRole(userActiveRole.roleName);
  const eventDocuments = useRoleDocuments({ eventToken: eventContext?.token, authToken: token,
    lang: getElakayLang()?.obj?.code || 'en', viewedRole: userActiveRole.roleName,
    enabled: Boolean(eventContext && showRole), loadAccess: false });
  const eventProfileComplete = !eventContext || eventContext.profileComplete !== false;
  const eventDocumentsReady = !eventContext || Object.values(eventDocuments.statuses).every(status => status === DOCUMENT_STATUS.SUCCESS);
  // A resolved Seller/Provider Promotion Token whose type matches the role
  // being requested: the Agent is already fixed by the token, so the
  // search/select grid is skipped -- everything else in this step
  // (location, categories, "about yourself") is still collected.
  const promoTokenActive =
    !!promoContext &&
    promoContext.promotionType === userActiveRole.roleName?.toLowerCase();
  const defaultAddress = useMemo(() => userActiveRole.address || {}, [userActiveRole.address]);
  const [step, setStep] = useState(approvalRequired ? 0 : 1);
  const [checks, setChecks] = useState({ objective: false, terms: false, final: false });
  const [location, setLocation] = useState({
    address: defaultAddress.Address1 || "",
    country: defaultAddress.country || "",
    city: defaultAddress.city || "",
    state: defaultAddress.State || "",
    zipCode: defaultAddress.postalCode || "",
    latitude: defaultAddress.latitude || "",
    longitude: defaultAddress.longitude || ""
  });
  const [agents, setAgents] = useState([]);
  const [agentPage, setAgentPage] = useState(1);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [applicationAnswers, setApplicationAnswers] = useState(EMPTY_APPLICATION_ANSWERS);
  const [applicationValidationAttempted, setApplicationValidationAttempted] = useState(false);
  const [socialLinks, setSocialLinks] = useState([]);
  const [preferredLanguages, setPreferredLanguages] = useState([]);
  const [profileAgent, setProfileAgent] = useState(null);
  const [selectedAgents, setSelectedAgents] = useState([]);
  const selectionCap = Number.isFinite(Number(maxAgentSelections))
    ? Number(maxAgentSelections)
    : null;
  const [agentSelectionLimit, setAgentSelectionLimit] = useState(selectionCap || 3);
  const [loadingAgents, setLoadingAgents] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [showRoyaltyConfirmation, setShowRoyaltyConfirmation] = useState(false);
  const topRef = useRef(null);
  const eventToken = eventContext?.token;
  useEffect(() => {
    if (eventToken) setChecks({ objective: false, terms: false, final: false });
  }, [eventToken, eventDocuments.agreementVersion, eventDocuments.language]);

  const tr = (key, fallback) =>
    infoSource?.laguangeElakay?.("roleChangeRequest", infoSource.languageAPI)?.[key] || fallback;
  const profileTr = (key, fallback) =>
    infoSource?.laguangeElakay?.("agentProfile", infoSource.languageAPI)?.[key] || fallback;
  const buttonText = (key, fallback) =>
    infoSource?.laguangeElakay?.("Button", infoSource.languageAPI)?.[key] || fallback;
  const applicationAnswersComplete = REQUIRED_APPLICATION_KEYS.every(
    (key) => applicationAnswers[key].trim()
  );
  // Links are optional, but a half-filled or invalid row blocks "Next".
  const socialLinksValid = validateApplicationLinks(socialLinks).valid;
  // Location/categories are pre-filled from the Agent for a promo-token
  // request (no search step to validate them), but they stay editable --
  // re-check completeness here since the visitor can clear them.
  const promoLocationComplete = !!(
    location.country.trim() &&
    location.city.trim() &&
    location.state.trim() &&
    location.zipCode.trim() &&
    selectedCategories.length
  );

  useEffect(() => {
    if (!showRole) return;
    setStep(approvalRequired ? 0 : 1);
    setChecks({ objective: false, terms: false, final: false });
    setAgents([]);
    setAgentPage(1);
    setApplicationAnswers(EMPTY_APPLICATION_ANSWERS);
    setApplicationValidationAttempted(false);
    setSocialLinks([]);
    setSelectedAgents([]);
    setAgentSelectionLimit(selectionCap || 3);
    setMessage("");
    setError("");
    setShowRoyaltyConfirmation(false);

    if (promoTokenActive) {
      // The Agent is already fixed by the token -- auto-fill from the
      // Agent's own profile instead of asking the visitor to redo work
      // that only mattered for the (now-skipped) search/match step. The
      // visitor only has to fill "Tell us about yourself".
      const agentLocation = promoContext.agent?.location || {};
      setLocation({
        address: "",
        country: agentLocation.country || "",
        city: agentLocation.city || "",
        state: agentLocation.state || "",
        zipCode: agentLocation.zipCode || "",
        latitude: "",
        longitude: ""
      });
      setSelectedCategories(promoContext.agent?.categoryPublicIds || []);
      setPreferredLanguages(promoContext.agent?.languages || []);
    } else {
      setLocation({
        address: defaultAddress.Address1 || "",
        country: defaultAddress.country || "",
        city: defaultAddress.city || "",
        state: defaultAddress.State || "",
        zipCode: defaultAddress.postalCode || "",
        latitude: defaultAddress.latitude || "",
        longitude: defaultAddress.longitude || ""
      });
      setSelectedCategories([]);
      setPreferredLanguages([]);
    }
  }, [showRole, approvalRequired, userActiveRole.roleName, selectionCap, promoTokenActive, promoContext, defaultAddress]);

  const steps = approvalRequired
    ? [
        tr("chooseAssociate", "Choose Your Agent"),
        tr("objective", "Objective"),
        tr("terms", "Terms and Conditions"),
        tr("finalAgreement", "Final Agreement")
      ]
    : [tr("objective", "Objective"), tr("terms", "Terms and Conditions"), tr("finalAgreement", "Final Agreement")];

  const goTo = (next) => {
    setError("");
    setStep(next);
    topRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const searchAgents = async () => {
    if (!applicationAnswersComplete) setApplicationValidationAttempted(true);
    if (!location.country.trim() || !location.city.trim() || !location.state.trim() || !location.zipCode.trim() || !selectedCategories.length) {
      setError(tr("locationRequired", elakayAutoText("h_d28c6448c686cf", "Country, city, state, ZIP code and at least one category are required.")));
      return;
    }
    if (!applicationAnswersComplete || !socialLinksValid) {
      setApplicationValidationAttempted(true);
      setError(!applicationAnswersComplete
        ? tr("applicationAnswersRequired", elakayAutoText("h_57f6d701808ee5", "Please tell us about yourself before continuing."))
        : tr("invalidUrl", "Invalid URL. Enter a full address starting with http:// or https://."));
      return;
    }
    setLoadingAgents(true);
    setError("");
    setSelectedAgents([]);
    try {
      const data = await findRoleChangeAssociates(token, {
        ...location,
        categories: selectedCategories.join(","),
        languages: preferredLanguages.join(",")
      });
      setAgents(data.agents || []);
      const configuredMaximum = Number(data.maximumAgentRequests) || 3;
      setAgentSelectionLimit(selectionCap
        ? Math.min(selectionCap, configuredMaximum)
        : configuredMaximum);
      setAgentPage(1);
      if (!(data.agents || []).length) {
        setError(tr("noAgents", elakayAutoText("h_b953736be14f7d", "No eligible agent is currently available in your state.")));
      }
    } catch (requestError) {
      setAgents([]);
      setError(requestError.code ? tokenText(infoSource)(requestError.code) : requestError.message);
    } finally {
      setLoadingAgents(false);
    }
  };

  const requiredApplicationQuestion = {
    key: "aboutYourself",
    label: tr("aboutYourself", "Tell us about yourself.")
  };
  const optionalApplicationQuestions = [
    { key: "motivation", label: tr("applicationMotivation", "Why do you want to become a Seller or Provider on Elakay?") },
    { key: "longTermGoals", label: tr("longTermGoals", "What are your long-term goals?") },
    { key: "goals", label: tr("applicationGoals", "What do you expect from Elakay?") },
    { key: "communityContribution", label: tr("communityContribution", "What do you think you can contribute to the Elakay community?") },
    { key: "localCommunityImpact", label: tr("localCommunityImpact", "How will you help your community?") },
    { key: "additionalInformation", label: tr("additionalInformation", "Additional information you'd like to share.") }
  ];

  const eventApplication = () => (
    <label className="d-block">
      {tr("aboutYourself", "Tell us about yourself.")}
      <textarea
        className="form-control"
        required
        maxLength={3000}
        rows={3}
        value={applicationAnswers.aboutYourself}
        onChange={(e) => setApplicationAnswers((current) => ({ ...current, aboutYourself: e.target.value }))}
      />
    </label>
  );

  const renderContent = (section) => {
    if (eventContext) {
      const key = { objective: 'plan', terms: 'term', final: 'agree' }[section];
      return <RoleDocumentContent infoSource={infoSource} status={eventDocuments.statuses[key]} document={eventDocuments.documents[key]} errorCode={eventDocuments.error?.code} onRetry={eventDocuments.retry} />;
    }
    const data = infoSource.laguangeElakay(content[section], infoSource.languageAPI);
    const missing = !data || (Array.isArray(data) && !data.length);
    return missing ? (
      <ElakayImage preset="avatar" className="shadow-lg role-request-empty" src={nodata} alt={section} />
    ) : (
      <Pages classAlert="container" paragra0={data} />
    );
  };

  const agentTotalPages = Math.max(1, Math.ceil(agents.length / AGENTS_PER_PAGE));
  const visibleAgents = agents.slice(
    (agentPage - 1) * AGENTS_PER_PAGE,
    agentPage * AGENTS_PER_PAGE
  );

  const submit = async (royaltyConfirmed = false) => {
    if (submitting || !eventProfileComplete || !eventDocumentsReady || !requestApprovalComplete || !Object.values(checks).every(Boolean)) return;
    if (eventContext && !externalApplication && !applicationAnswersComplete) {
      setError(tokenText(infoSource)('APPLICATION_REQUIRED'));
      return;
    }
    const currentRole = String(userActiveRole.UserRoleName || "user").trim();
    const hasHigherRole =
      userActiveRole.roleName === "Royalty" &&
      !["", "user", "customer", "royalty"].includes(currentRole.toLowerCase());
    if (hasHigherRole && !royaltyConfirmed) {
      setShowRoyaltyConfirmation(true);
      return;
    }
    setSubmitting(true);
    setError("");
    try {
      if (eventContext) {
        await acceptEventRoleToken(token, {
          eventToken: eventContext.token,
          agreementLanguage: eventDocuments.language,
          agreementVersion: eventDocuments.agreementVersion,
          confirmations: { objectiveRead: checks.objective, termsAccepted: checks.terms, finalAgreementAccepted: checks.final },
          applicationAnswers: externalApplication?.applicationAnswers || applicationAnswers,
          socialLinks: cleanApplicationLinks(externalApplication?.socialLinks || []),
          categoryPublicIds: externalApplication?.categoryPublicIds || [],
          preferredLanguages: externalApplication?.preferredLanguages || [],
        });
        await onEventAccepted?.();
        return;
      }
      if (approvalRequired && userActiveRole.roleName !== "Royalty") {
        const data = await createRoleChangeRequest(token, {
          requestedRole: userActiveRole.roleName,
          // A promo token resolves its own Agent server-side -- the client
          // never chooses one, so associatePublicIds is omitted entirely
          // rather than sent empty (see roleChangeRequest.js createRequest).
          ...(promoTokenActive
            ? { promoToken: promoContext.token }
            : { associatePublicIds: selectedAgents.map((agent) => agent.publicId) }),
          location,
          categoryPublicIds: selectedCategories,
          confirmations: {
            objectiveRead: checks.objective,
            termsAccepted: checks.terms,
            finalAgreementAccepted: checks.final
          },
          applicationAnswers,
          socialLinks: cleanApplicationLinks(socialLinks),
          preferredLanguages
        });
        setMessage(data.message);
        onRequestCreated?.();
        return;
      }
      if (!userActiveRole.roleName || !userActiveRole.role || !userActiveRole.endDate) {
        setError(tr("incompleteRoleRequest", elakayAutoText("h_3f92d20f852952", "This request is incomplete. Please close this window and try again.")));
        return;
      }
      const data = await UserStepUP(token, {
        customer: userActiveRole.customer,
        seller: userActiveRole.seller,
        provider: userActiveRole.provider,
        role: userActiveRole.role,
        roleName: userActiveRole.roleName,
        level: userActiveRole.level,
        endDate: userActiveRole.endDate,
        [userActiveRole.roleName]: true,
        agreeRole: true
      });
      if (data.requestScheduled) {
        setShowRoyaltyConfirmation(false);
        setMessage(data.message);
        onRequestCreated?.();
        return;
      }
      setShowRole(false);
      authenticate(data, () => {});
    } catch (requestError) {
      setError(requestError.code ? tokenText(infoSource)(requestError.code) : requestError.message);
    } finally {
      setSubmitting(false);
    }
  };

  const proximity = (agent) => {
    if (agent.proximity === "same_zip") return tr("sameZip", "Same ZIP code");
    if (agent.proximity === "same_city") return tr("sameCity", "Same city");
    if (agent.distanceMiles != null) return tr("milesAway", "{distance} miles away").replace("{distance}", agent.distanceMiles);
    return tr("sameState", "Same state");
  };

  const chooseAssociate = () => (
    <div className="role-request-choose">
      {!promoTokenActive && (
        <div className="role-request-explanation">
          <h3>{tr("whyChoose", "Why choose an Agent?")}</h3>
          <p>{tr("associateExplanation", "Your selected Agent will guide you, help you understand Elakay tools and rules, support your business setup, and review your request. The Agent may approve or reject it; selection does not guarantee role activation.")}</p>
        </div>
      )}
      {promoTokenActive && (
        <div className="role-request-explanation">
          <h3>{tr("promoTokenPrefilled", "Pre-filled from your Agent")}</h3>
          <p>{tr("promoTokenPrefilledHelp", "Your Agent's location and categories were filled in automatically — feel free to add more categories or change the location if it doesn't match what you're applying for.")}</p>
        </div>
      )}
      {/* Location and categories stay editable even with a Promotion Token
          — only pre-filled from the Agent as a starting point (spec change:
          the visitor can still add categories / change the location). */}
      <CountryZipLocationFields
        value={location}
        onChange={setLocation}
        infoSource={infoSource}
        className="role-request-location-grid"
      />
      <ThirdLevelCategorySelector
        token={token}
        infoSource={infoSource}
        selectedCategoryIds={selectedCategories}
        onSelectionChange={setSelectedCategories}
        pageSize={12}
        paginationEnabled
        mode={userActiveRole.roleName === "Seller" ? "seller-onboarding" : "provider-onboarding"}
      />
      {!promoTokenActive && (
        <LanguageSelector
          infoSource={infoSource}
          selectedCodes={preferredLanguages}
          onChange={setPreferredLanguages}
          title={tr("preferredLanguages", "Preferred Languages")}
          help={tr("preferredLanguagesHelp", "Optional. Choose one or more languages for Agent matching.")}
        />
      )}
      <section className="role-request-application">
        <h3>{tr("applicationInformation", "Application Information")}</h3>
        <p>
          {promoTokenActive
            ? tr("applicationInformationHelpPromo", "Just tell us about yourself to finish your application.")
            : tr("applicationInformationHelp", "Help us understand your goals and how Elakay can support you.")}
        </p>
        <ExpandableTextarea
          id={`application-${requiredApplicationQuestion.key}`}
          label={requiredApplicationQuestion.label}
          value={applicationAnswers[requiredApplicationQuestion.key]}
          required
          forceError={applicationValidationAttempted}
          placeholder={tr("clickToAnswer", "Click here to answer…")}
          errorMessage={{
            requiredLabel: tr("required", "Required *"),
            validation: tr("requiredAnswer", "This answer is required.")
          }}
          onChange={(value) => {
            setApplicationAnswers((current) => ({ ...current, [requiredApplicationQuestion.key]: value }));
            if (value.trim()) setError("");
          }}
        />
        <ExpandableTextarea
          id="application-experience"
          label={tr("applicationExperience", "Experience / Relevant Experience")}
          value={applicationAnswers.experience}
          placeholder={tr("clickToAnswer", "Click here to answer…")}
          onChange={(value) => setApplicationAnswers((current) => ({ ...current, experience: value }))}
        />
        {!promoTokenActive && (
        <ExpandableApplicationSection
          label={tr("addMoreInformation", "Add more information (Optional)")}
          closeLabel={tr("hideAdditionalQuestions", "Hide additional questions")}
        >
          {optionalApplicationQuestions.map((question) => (
            <ExpandableTextarea
              key={question.key}
              id={`application-${question.key}`}
              label={question.label}
              value={applicationAnswers[question.key]}
              placeholder={tr("clickToAnswer", "Click here to answer…")}
              onChange={(value) => setApplicationAnswers((current) => ({ ...current, [question.key]: value }))}
            />
          ))}
        </ExpandableApplicationSection>
        )}
        <ApplicationLinksEditor
          idPrefix="role-request-links"
          infoSource={infoSource}
          links={socialLinks}
          onChange={setSocialLinks}
          showErrors={applicationValidationAttempted}
        />
      </section>
      {promoTokenActive && (
        <div className="role-request-promo-agent">
          <h3>{tr("yourAgent", "Your Agent")}</h3>
          <div className="role-request-agent-card selected" role="presentation">
            {promoContext.agent?.avatarUrl
              ? <ElakayImage preset="avatar" src={promoContext.agent.avatarUrl} alt="" />
              : <span className="role-request-avatar">{promoContext.agent?.initials || "EA"}</span>}
            <span className="role-request-agent-main">
              <strong>{promoContext.agent?.displayName}</strong>
              <small>{tr("promoTokenAgentLocked", "This promotion link is bound to this Agent — it can't be changed.")}</small>
            </span>
          </div>
        </div>
      )}
      {!promoTokenActive && (
      <>
      <button type="button" className="btn btn-info role-request-search" onClick={searchAgents} disabled={loadingAgents}>
        {loadingAgents ? tr("searching", "Searching…") : tr("searchAgents", "Find available agents")}
      </button>
      <div className="role-request-agent-grid">
        {visibleAgents.map((agent) => (
          (() => {
          const selected = selectedAgents.some((item) => item.publicId === agent.publicId);
          const toggleAgent = () => {
            if (selected) {
              setSelectedAgents((current) => current.filter((item) => item.publicId !== agent.publicId));
            } else if (selectedAgents.length < agentSelectionLimit) {
              setSelectedAgents((current) => [...current, agent]);
            } else {
              setError(
                tr("maximumAgents", elakayAutoText("h_c2c6f09b1e3700", "You can select a maximum of {count} Agents."))
                  .replace(elakayAutoText("h_45e7ea0dbd5621", "{count}"), agentSelectionLimit)
              );
            }
          };
          return (
          <div
            role="button"
            tabIndex={0}
            key={agent.publicId}
            className={`role-request-agent-card ${selected ? "selected" : ""}`}
            onClick={toggleAgent}
            onKeyDown={(event) => {
              if (event.key === "Enter" || event.key === " ") toggleAgent();
            }}
          >
            {agent.avatarUrl || agent.avatar ? <ElakayImage preset="avatar" src={agent.avatarUrl || agent.avatar} alt="" /> : <span className="role-request-avatar">{agent.initials}</span>}
            <span className="role-request-agent-main">
              <strong>{agentCardName(agent)}</strong>
              <span>{agent.city}, {agent.state}, {agent.country}</span>
              <small>{proximity(agent)}</small>
              <small className="role-request-match-count">
                {tr("matchingCategories", "{count} matching categories").replace("{count}", agent.matchingCategoryCount || 0)}
              </small>
              <span className="role-request-card-buttons">
                <button type="button" onClick={async (event) => {
                  event.stopPropagation();
                  try { setProfileAgent(await getPublicAgentProfile(agent.publicId)); }
                  catch (requestError) { setError(requestError.message); }
                }}>{tr("viewProfile", "View Profile")}</button>
                <span>{selected ? tr("selected", "Selected") : tr("selectAgent", "Select Agent")}</span>
              </span>
            </span>
          </div>
          );
          })()
        ))}
      </div>
      <div className="role-request-selected-count">
        {tr("agentsSelected", "Selected: {count} / {maximum}")
          .replace("{count}", selectedAgents.length)
          .replace("{maximum}", agentSelectionLimit)}
      </div>
      {agents.length > 0 && (
        <nav className="role-request-agent-pagination" aria-label={tr("agentPagination", "Agent pagination")}>
          <button
            type="button"
            disabled={agentPage <= 1}
            onClick={() => setAgentPage((current) => Math.max(1, current - 1))}
          >
            {buttonText("previous", "Previous")}
          </button>
          <span>
            {tr("pageOf", "Page {page} of {total}")
              .replace("{page}", agentPage)
              .replace("{total}", agentTotalPages)}
          </span>
          <button
            type="button"
            disabled={agentPage >= agentTotalPages}
            onClick={() => setAgentPage((current) => Math.min(agentTotalPages, current + 1))}
          >
            {buttonText("next", "Next")}
          </button>
        </nav>
      )}
      <Modal size="lg" show={!!profileAgent} onHide={() => setProfileAgent(null)} centered>
        <Modal.Header closeButton><Modal.Title>{`${profileAgent?.firstname || ""} ${profileAgent?.lastname || ""}`.trim()}</Modal.Title></Modal.Header>
        <Modal.Body>
          {profileAgent && <div className="agent-public-profile">
            <ElakayImage preset="avatar" src={profileAgent.profile?.avatarUrl} alt="" />
            <div>
              {/* <span className="agent-public-role">{profileAgent.role}</span> */}
            <h3>{`${profileAgent.firstname || ""} ${profileAgent.lastname || ""}`.trim()}</h3><p>{profileAgent.profile?.biography}</p></div>
            <section><h4>{tr("experience", "Experience")}</h4><p>{profileAgent.profile?.experience}</p></section>
            <ProfessionalVideoPlayer professionalVideos={profileAgent.profile?.professionalVideos} tr={profileTr} />
            <section><SpecializedCategories categories={profileAgent.categories || []} title={tr("specializedCategories", "Specialized Categories")} /></section>
            <section><LanguageBadges codes={profileAgent.profile?.languages || []} infoSource={infoSource} title={tr("languagesSpoken", "Languages Spoken")} /></section>
            <section><h4>{tr("location", "Location")}</h4><p>{profileAgent.profile?.location?.city}, {profileAgent.profile?.location?.state}, {profileAgent.profile?.location?.country}</p>{profileAgent.profile?.publicPhone && <p>{profileAgent.profile.publicPhone}</p>}</section>
          </div>}
        </Modal.Body>
      </Modal>
      </>
      )}
      <div className="role-request-actions">
        <span />
        <button
          type="button"
          className="btn btn-primary"
          disabled={
            (!promoTokenActive && !selectedAgents.length) ||
            (promoTokenActive && !promoLocationComplete) ||
            !applicationAnswersComplete ||
            !socialLinksValid
          }
          onClick={() => goTo(1)}
        >
          {buttonText("next", "Next")}
        </button>
      </div>
    </div>
  );

  const finalAgreement = (showContent = true) => (
    <>
      {showContent && renderContent("final")}
      {inlineFinalOnly && eventContext && !externalApplication && eventApplication()}
      {!eventProfileComplete && <div className="alert alert-info"><p>{tokenText(infoSource)('PROFILE_REQUIRED')}</p>
        <Link className="btn btn-outline-primary" to={`/profile?returnUrl=${encodeURIComponent(`/user-step?t=${encodeURIComponent(eventContext.token)}`)}`}>{tokenText(infoSource)('completeProfile')}</Link>
      </div>}
      <div className="role-request-checks">
        <label htmlFor="role-objective-read" className={checks.objective ? "selected" : ""}>
          <input
            id="role-objective-read"
            type="checkbox"
            checked={checks.objective}
            required
            onChange={(e) => setChecks((current) => ({ ...current, objective: e.target.checked }))}
          />
          <span>{tr("objectiveRead", "I have read the objective.")}</span>
        </label>
        <label htmlFor="role-terms-accepted" className={checks.terms ? "selected" : ""}>
          <input
            id="role-terms-accepted"
            type="checkbox"
            checked={checks.terms}
            required
            onChange={(e) => setChecks((current) => ({ ...current, terms: e.target.checked }))}
          />
          <span>{tr("termsAccepted", "I accept the terms and conditions.")}</span>
        </label>
        <label htmlFor="role-final-agreement" className={checks.final ? "selected" : ""}>
          <input
            id="role-final-agreement"
            type="checkbox"
            checked={checks.final}
            required
            onChange={(e) => setChecks((current) => ({ ...current, final: e.target.checked }))}
          />
          <span>{tr("finalAccepted", "I confirm the final agreement.")}</span>
        </label>
        {eventContext?.requestApproval === true && <label className={requestApprovalComplete ? "selected" : ""}>
          <input type="checkbox" checked={requestApprovalComplete} readOnly aria-readonly="true" />
          <span>{tr("requestApprovalInformationComplete", "Request Approval Information Complete")}</span>
        </label>}
      </div>
      {eventContext?.requestApproval === true && !requestApprovalComplete && <div className="alert alert-warning">
        <p>{tr("requestApprovalIncomplete", "Request Approval information is incomplete.")}</p>
        <button type="button" className="btn btn-outline-primary" onClick={onCompleteRequestApproval}>{tr("completeRequestApproval", "Complete Request Approval")}</button>
      </div>}
      <div className="role-request-actions">
        {!inlineFinalOnly && <button type="button" className="btn btn-primary" onClick={() => goTo(2)}>{buttonText("previous", "Previous")}</button>}
        <button type="button" className="btn btn-info" disabled={!eventProfileComplete || !eventDocumentsReady || !requestApprovalComplete || (eventContext && !externalApplication && !applicationAnswersComplete) || !Object.values(checks).every(Boolean) || submitting} onClick={() => submit()}>
          {submitting ? tr("submitting", "Submitting…") : approvalRequired ? tr("submitRequest", "Submit request") : buttonText("actUser", "Activate user")}
        </button>
      </div>
    </>
  );

  if (inlineFinalOnly) return <div className="event-inline-agreement">
    {error && <div className="alert alert-danger">{error}</div>}
    {message ? <div className="role-request-success"><h3>{tr("requestPendingTitle", "Request submitted")}</h3><p>{tr("requestPending", "Your request is waiting for approval.")}</p></div> : finalAgreement(false)}
  </div>;

  return (
    <>
      <Modal size="xl" show={showRole} onHide={() => setShowRole(false)} dialogClassName="modal-90w" centered={Boolean(eventContext || promoContext?.type === 'EVENT_ROLE_TOKEN')} contentClassName={eventContext || promoContext?.type === 'EVENT_ROLE_TOKEN' ? 'uart-modal-content' : undefined}>
        <Modal.Header closeButton>
          <Modal.Title>{tr("allAbout", "All to know about")} {roleDisplayLabel(userActiveRole.roleName)}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div ref={topRef}>
            <ol className={`role-request-progress ${approvalRequired ? "four" : "three"}`}>
              {steps.map((label, index) => <li key={label} className={index <= (approvalRequired ? step : step - 1) ? "active" : ""}>{label}</li>)}
            </ol>
            {error && <div className="alert alert-danger">{error}</div>}
            {message ? (
              <div className="role-request-success">
                <h3>{tr("requestPendingTitle", "Request submitted")}</h3>
                <p>{tr("requestPending", "Your request is waiting for approval from the selected Associate.")}</p>
                <button className="btn btn-primary" onClick={() => setShowRole(false)}>{buttonText("close", "Close")}</button>
              </div>
            ) : (
              <>
                {step === 0 && approvalRequired && chooseAssociate()}
                {step === 1 && <>{renderContent("objective")}
                  {eventContext && eventApplication()}<div className="role-request-actions">{approvalRequired ? <button className="btn btn-primary" onClick={() => goTo(0)}>{buttonText("previous", "Previous")}</button> : <span />}<button className="btn btn-primary" disabled={eventContext && (!eventDocumentsReady || !applicationAnswers.aboutYourself.trim())} onClick={() => goTo(2)}>{buttonText("next", "Next")}</button></div></>}
                {step === 2 && <>{renderContent("terms")}<div className="role-request-actions"><button className="btn btn-primary" onClick={() => goTo(1)}>{buttonText("previous", "Previous")}</button><button className="btn btn-primary" onClick={() => goTo(3)}>{buttonText("next", "Next")}</button></div></>}
                {step === 3 && finalAgreement()}
              </>
            )}
            {!token && <Link to="/signin">{buttonText("signfirst", "Sign in first")}</Link>}
          </div>
        </Modal.Body>
      </Modal>
      {/* NOTE: reconstructed 2026-08-18 -- no backup captured this modal's
          exact original text; the surrounding logic (showRoyaltyConfirmation
          / submit(royaltyConfirmed)) was untouched by the deletion, this is
          the UI that was missing to drive it. Please double-check wording. */}
      <Modal show={showRoyaltyConfirmation} onHide={() => setShowRoyaltyConfirmation(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>{tr("royaltyConfirmTitle", "Confirm role change")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{tr("royaltyConfirmBody", "You currently have a higher role than Royalty. Are you sure you want to switch?")}</p>
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="btn btn-secondary" onClick={() => setShowRoyaltyConfirmation(false)}>
            {buttonText("cancel", "Cancel")}
          </button>
          <button type="button" className="btn btn-primary" disabled={submitting} onClick={() => submit(true)}>
            {submitting ? tr("submitting", "Submitting…") : buttonText("confirm", "Confirm")}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default StepAboutUser;
